module.exports = __webpack_public_path__ + "static/media/nav-order.6874521a.svg";